//- Set current Year to footer Copyright
let thisDate = new Date();
document.querySelector('#year').innerHTML = thisDate.getFullYear();